import { Link } from "react-router-dom";
import { useApi } from "@/hooks/useApi";
import { useNow } from "@/hooks/useNow";
import type { TugBrief } from "@/lib/types";
import { SkeletonCard } from "@/components/base/Skeleton";
import TugCard from "@/pages/tug/components/TugCard";

// 메인 홈 «줄다리기» 섹션.
// rps.php 와 달리 «진행중 경기가 0건이면 렌더링하지 않는다» (가이드 규칙).
// 위치는 «가위바위보» 섹션 바로 아래.
export default function TugSection() {
  const { data, loading, serverTs } = useApi<TugBrief[]>("tug.php?live=1");
  const now = useNow();

  const list = data ?? [];
  // 진행중 경기가 없으면 흔적 없이 사라진다.
  if (!loading && list.length === 0) return null;

  const elapsed = serverTs ? Math.max(0, now / 1000 - serverTs) : 0;
  const scroll = list.length >= 3;

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              <span aria-hidden="true">🪢</span>
              단체 줄다리기
            </h2>
            <p className="mt-2 text-foreground-600">
              두 팀으로 나눠 화면을 두드리는 팀 대항 게임. 점수는 종료 후 공개됩니다.
            </p>
          </div>
          <Link
            to="/tug"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
          >
            전체 보기
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 3 }).map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        ) : scroll ? (
          <div className="-mx-4 flex gap-5 overflow-x-auto px-4 pb-2 md:mx-0 md:px-0">
            {list.map((r) => (
              <div key={r.no} className="w-[320px] shrink-0">
                <TugCard brief={r} elapsed={elapsed} />
              </div>
            ))}
          </div>
        ) : (
          <div
            className={`grid grid-cols-1 gap-5 ${
              list.length > 1 ? "md:grid-cols-2" : ""
            }`}
          >
            {list.map((r) => (
              <TugCard key={r.no} brief={r} elapsed={elapsed} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}